export const NAV = {
	home: 'nav-tab-home',
	music: 'nav-tab-music',
	videos: 'nav-tab-videos',
	upload: 'nav-tab-upload',
	profile: 'nav-tab-profile',
	logo: 'nav-logo-link',
	signIn: 'nav-sign-in-button',
	join: 'nav-join-button',
	userButton: 'nav-user-button',
};

export const LANDING = {
	hero: 'landing-hero',
	joinCreator: 'landing-join-creator-button',
	joinFan: 'landing-join-fan-button',
	exploreMusic: 'landing-explore-music-button',
	creatorsList: 'landing-creators-list',
	creatorCard: 'landing-creator-card',
	plaques: 'landing-plaques-section',
	memberships: 'landing-memberships-section',
	chart: 'landing-chart-section',
};

export const ONBOARD = {
	page: 'onboarding-page',
	roleCreator: 'onboarding-role-creator',
	roleFan: 'onboarding-role-fan',
	displayName: 'onboarding-display-name-input',
	username: 'onboarding-username-input',
	submit: 'onboarding-submit-button',
	error: 'onboarding-error',
};

export const PROFILE = {
	page: 'profile-page',
	avatar: 'profile-avatar',
	avatarInput: 'profile-avatar-file-input',
	avatarButton: 'profile-avatar-change-button',
	displayName: 'profile-display-name',
	username: 'profile-username',
	role: 'profile-role-badge',
	bio: 'profile-bio',
	editButton: 'profile-edit-button',
	signOut: 'profile-sign-out-button',
	membership: 'profile-membership-tier',
	shareLink: 'profile-public-link',
};

export const EDIT_PROFILE = {
	dialog: 'edit-profile-dialog',
	displayName: 'edit-profile-display-name-input',
	username: 'edit-profile-username-input',
	bio: 'edit-profile-bio-input',
	save: 'edit-profile-save-button',
	cancel: 'edit-profile-cancel-button',
	error: 'edit-profile-error',
};

export const PAGES = {
	music: 'music-page',
	videos: 'videos-page',
	upload: 'upload-page',
	publicProfile: 'public-profile-page',
	notFound: 'public-profile-not-found',
};

export const PLAYER = {
	mini: 'mini-player',
	expand: 'mini-player-expand',
	title: 'player-track-title',
	artist: 'player-track-artist',
	toggle: 'mini-player-toggle',
	close: 'mini-player-close',
	full: 'full-player',
	fullToggle: 'full-player-toggle',
	seek: 'player-seek-slider',
	volume: 'player-volume-slider',
	mute: 'player-mute-button',
	prev: 'player-prev-button',
	next: 'player-next-button',
	current: 'player-current-time',
	duration: 'player-duration',
	trackLink: 'player-track-link',
};
